var React = require('react');

function Google (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.2 2a9.9 9.9 0 0 1 6.83 2.6L16.1 7.46l-.2-.18a5.61 5.61 0 0 0-3.7-1.32 6.09 6.09 0 0 0-5.74 4.13 5.88 5.88 0 0 0 0 3.83 6.1 6.1 0 0 0 5.74 4.12 6.2 6.2 0 0 0 3.47-.95c1-.65 1.7-1.65 1.98-2.8l.05-.24h-5.5V10.2h9.61c.12.67.18 1.35.18 2.03a9.67 9.67 0 0 1-3.04 7.36 9.76 9.76 0 0 1-6.4 2.4l-.36.01c-3.86 0-7.38-2.13-9.11-5.5l-.15-.3a9.83 9.83 0 0 1 .17-8.7l.14-.27A10.23 10.23 0 0 1 12.2 2z"}));
}

Google.defaultProps = {"width":"24","height":"24","aria-label":"Google","viewBox":"0 0 24 24"};

module.exports = Google;

Google.default = Google;
